import { createContext } from 'react';

import type { AxisId, AnyXYChartScale } from '../types/xy-chart-internals.js';

export type AxisIdToScales = Map<
  AxisId,
  {
    currentScale: AnyXYChartScale;
    initialScale: AnyXYChartScale;
  }
>;

export const XYChartScalesContext = createContext<AxisIdToScales | undefined>(
  undefined,
);

XYChartScalesContext['displayName'] = 'XYChartScalesContext';
